<template>
    <div>
      <van-nav-bar
        :title="$t('app.information.title')"
        :left-text="$t('app.common.back')"
        left-arrow
        @click-left="$router.push('/member/members')"
      />
      <van-cell-group>
        <van-cell :title="$t('app.information.nick_name')" is-link :value="name" to='information/nick_name' />
        <van-cell :title="$t('app.information.real_name')" :is-link="realStatus" :value="real" @click="openReal" />
        <van-cell :title="$t('app.information.bank_card')" :is-link="bankStatus" :value="bank" @click="openBank"  />
        <van-cell :title="$t('app.information.phone')" is-link :value="phone"  to="information/bink_phone" />
        <van-cell :title="$t('app.information.email')" is-link :value="email"  to="information/bind_email" />
      </van-cell-group>
      <van-cell-group :title="$t('app.information.password')">
        <van-cell :title="$t('app.information.login_pass')" is-link :value="$t('app.information.set')" to="information/login_pass" />
        <van-cell :title="$t('app.information.withdraw_pass')" is-link :value="withdrawal" to="information/withdrawal_pass" />
      </van-cell-group>
    </div>
</template>

<script>
    export default {
      name: "Information",
      data(){
        return{
          name: this.$t('app.information.notset'),
          real: this.$t('app.information.unname'),
          realStatus:false,
          bank: this.$t('app.information.nobound'),
          phone:'',
          email: this.$t('app.information.notset'),
          withdrawal: this.$t('app.information.notset'),
          bankStatus:true
        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        getConfig(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "user_info",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function(res) {
              let resData = res.data;
              // console.log(resData);
              if (resData.code === 1) {
                resData.data.name === '' ? that.name = that.$t('app.information.notset') : that.name = resData.data.name;
                if (resData.data.real === null){
                  that.real = that.$t('app.information.unname');
                  that.realStatus = true;
                }else {
                  that.real = resData.data.real;
                  that.realStatus = false;
                }
                if (resData.data.bank === 0){
                  that.bank = that.$t('app.information.nobound');
                  //that.bankStatus = true;
                }else {
                  that.bank = that.$t('app.information.bound');
                  //that.bankStatus = false;
                }
                
                that.phone = resData.data.phone;

                that.$store.commit("changePhone", resData.data.phone1);
                resData.data.withdrawal === 0 ? that.withdrawal = that.$t('app.information.notset') : that.withdrawal = that.$t('app.information.set');
                resData.data.email === 0 ? that.email = that.$t('app.information.notset') : that.email = resData.data.email;

              } else if (resData.code === 0 || resData.code === -1) {
                that.$toast.fail(that.$t(resData.msg));
              }
            });
        },
        openReal(){
          let that = this;
          if (that.realStatus){
            that.$router.push('information/real_name');
          }
        },
        openBank(){
          let that = this;
          // if (that.bankStatus){
          //   that.$router.push('information/bind_bank');
          // }
          that.$router.push('information/bind_bank');
        }
      },
      mounted:function () {
        let that = this;
        that.isLogin();
        that.getConfig();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Information.vue